import {config} from '@/core/config/base'
import {storageLocal} from '@/core/libs/storage'
export const auth = {
  loggedIn: function (to, from = null) {
    return new Promise((resolve, reject) => {
      storageLocal.get([config.jwt, 'user_role'])
        .then(
          storage => {
            if (storage) {
              let jwtToken = storage[0]
              let role = parseInt(storage[1])
              if (to.meta.auth) {
                let roleMatch = -1
                let roles = to.meta.roles
                let expiration = 0
                if (jwtToken !== null) {
                  let base64Url = jwtToken.split('.')[1]
                  let base64 = base64Url.replace('-', '+').replace('_', '/')
                  let payload = JSON.parse(window.atob(base64))
                  expiration = payload.exp * 1000
                }
                let now = new Date().getTime()
                if (roles !== undefined) {
                  roleMatch = roles.indexOf(role)
                }
                if (roleMatch < 0 || !jwtToken || expiration < now) {
                  this.logout()
                  resolve({
                    auth: false,
                    route: 'login'
                  })
                } else {
                  resolve({
                    auth: true,
                    route: 'home'
                  })
                }
              } else {
                if (jwtToken !== null && to.meta.roles === null) {
                  resolve({
                    auth: true,
                    route: 'home'
                  })
                } else {
                  resolve({
                    auth: false,
                    route: 'login'
                  })
                }
              }
            } else {
              resolve({
                auth: false,
                route: 'login'
              })
            }
          }
        )
    })
  },
  logout: function () {
    return new Promise((resolve) => {
      let fields = [config.jwt, 'first_name', 'last_name', 'user_email', 'user_id', 'user_role', 'expires_in']
      let results = fields.map(element => {
        return Promise.resolve().then(function () {
          localStorage.removeItem(element)
        })
      })
      if (results) {
        resolve(results)
      }
    })
  },
  setSession: function (response) {
    let promise1 = storageLocal.set(config.jwt, response.access_token)
    let promise2 = storageLocal.set('first_name', response.name)
    let promise3 = storageLocal.set('last_name', response.last_name)
    let promise4 = storageLocal.set('user_email', response.email)
    let promise5 = storageLocal.set('user_id', response.user_id)
    let promise6 = storageLocal.set('user_role', response.role_id)
    let promise7 = storageLocal.set('expires_in', response.expires_in)
    return new Promise(resolve => {
      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6, promise7])
        .then(
          result => {
            resolve(true)
          }
        )
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/libs/sessions.js